import React, { useState } from 'react'
import {
  Card,
  Table,
  Button,
  Row,
  Col,
  message,
  Modal,
  Spin,
  Divider,
  Form,
  Switch,
  Avatar
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { useDispatch, useStore, useSelector } from 'react-redux'
import {
  loadAddCashModalShow,
  loadIsRegistorLoading
} from '../../../appRedux/actions/Sell'
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck
} from '../../../appRedux/actions/GlobalMethods'
import { loadEnableAllPOSLayouts, setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { SELL_SETTING } from '../../../constants/Pages'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import {
  getDecryptID,
  loadIsSelectReg,
  loadIsShowConfigAttribute,
  loadIsShowConfigSellLayout,
  StringIsNullOrEmpty
} from '../../../appRedux/actions'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import { StoreEntities } from '../../../constants/StoreEntities'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
const QuickLayoutListing = () => {

  const confirm = Modal.confirm;
  const store = useStore()
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getConfigSellAttribute = useSelector(
    ({ commonConfigs }) => commonConfigs.getConfigSellAttribute
  )
  const getConfigSellLayout = useSelector(
    ({ commonConfigs }) => commonConfigs.getConfigSellLayout
  )
  const getEnableAllPOSLayouts = useSelector(
    ({ commonConfigs }) => commonConfigs.getEnableAllPOSLayouts
  )
  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  )
  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const [isLoading, setIsLoading] = React.useState(true)
  const [getLayoutData, setLayoutData] = React.useState([])
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [getSelectedOutletID, setSelectedOutletID] = React.useState('')
  const [getSelectedRegID, setSelectedRegID] = React.useState('')
  const [getRegisterQuickkeys, setRegisterQuickkeys] = React.useState([])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!checkIsWeb().exist) {
        postDataToApp(PostAppTypes.PAGE_HEADER, 'sell.settings.settings')
      }

      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      let outlet = false
      if (getReduxSelectedStoreOutlets.id) {
        setSelectedOutletID(getReduxSelectedStoreOutlets.id)
        outlet = getReduxSelectedStoreOutlets.id
      } else {
        let selectedLocalOut = localStorage.getItem('selectedOut')
        if (selectedLocalOut) {
          selectedLocalOut = JSON.parse(selectedLocalOut)
          setSelectedOutletID(
            getReduxSelectedStoreOutlets.id
              ? getReduxSelectedStoreOutlets.id
              : selectedLocalOut.id
          )
          outlet = getReduxSelectedStoreOutlets.id
            ? getReduxSelectedStoreOutlets.id
            : selectedLocalOut.id
        } else {
          setSelectedOutletID('')
        }
      }
      let localRegID =
        localStorage.getItem('selectedReg') != ''
          ? JSON.parse(localStorage.getItem('selectedReg'))
          : false
      let regID =
        getReduxSelectedOutletReg && getReduxSelectedOutletReg.id
          ? getReduxSelectedOutletReg.id
          : localRegID && localRegID.id
          ? localRegID.id
          : false
      if (regID) {
        setSelectedRegID(regID)
      } else {
        setSelectedRegID('')
        message.info(
          'Kindly click Sell Menu & select Outlet/Register from left sidebar to open cash flow',
          6
        )
      }

      if (!outlet || !regID) {
        dispatch(loadIsSelectReg(true))
      }

      return () => (mounted = false)
    }
  }, [getReduxSelectedStoreOutlets, getReduxSelectedOutletReg])

  React.useEffect(() => {
    dispatch(setCommonConfigs(SELL_SETTING))
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      let body = {
        QuickKeyLayoutID: '',
        OutletID: getSelectedOutletID,
        RegisterID: getSelectedRegID
      }
      if (
        !StringIsNullOrEmpty(getSelectedOutletID) &&
        !StringIsNullOrEmpty(getSelectedRegID)
      ) {
        getQuickLayoutsListingService(body)
      }
      return () => (mounted = false)
    }
  }, [getSelectedRegID])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      return () => (mounted = false)
    }
  }, [getLayoutData])

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }
  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }
  async function getQuickLayoutsListingService (body) {
    const getLayouts = ds.getQuickKeyLayouts(body, BEHAVIOUR_TYPE.GET)
    await getLayouts
      .then(res => {
        if (res && res != '') {
          let data =
            res.data &&
            res.data.map((e, key) => {
              return {
                quickLayoutID: e.quicKKeyLayoutID,
                layoutName: e.layoutName,
                isCurrentLayout: e.isCurrentLayout,
                isActive : e.isActive,
                displaySeqNo :e.displaySeqNo
              }
            })
          setLayoutData(data)
          setIsLoading(false)
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
      })
  }
  async function postQuickKeyLayoutDataServices (body, methodType) {
    //
    const postLayoutData = ds.postQuickKeylayoutData(body, methodType)
    // ;
    await postLayoutData
      .then(res => {
        if (res && res.length > 0) {
          setIsLoading(false)
          let body = { QuickKeyLayoutID: '' }
          getQuickLayoutsListingService(body)
          message.success(res)
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something went wrong...");
        // }
      })
  }
  async function postQuickKeyCurrentLayout (body, methodType) {
    const postLayoutData = ds.postQuickKeyCurrentLayoutData(body, methodType)
    await postLayoutData
      .then(res => {
        //  ;
        if (res && res.msgCode == 'GENERAL_SUCCESS') {
          let newLayoutData =
            getLayoutData &&
            getLayoutData.map(x => {
              let isCurrentLayout =
                body.QuickKeyLayoutID &&
                getDecryptID(body.QuickKeyLayoutID) ==
                  getDecryptID(x.quickLayoutID)
                  ? true
                  : false
              return {
                quickLayoutID: x.quickLayoutID,
                layoutName: x.layoutName,
                isCurrentLayout: isCurrentLayout,
                displaySeqNo : x.displaySeqNo
              }
            })
          setLayoutData(newLayoutData)
          setIsLoading(false)
          //let bodyListing = { QuickKeyLayoutID: "" };
          // getQuickLayoutsListingService(bodyListing);
          message.success(res.msgDescription)
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
      })
  }
  async function CreateDefaultQuickKeyLayout (body) {
    const methType =
      body.BehaviorName && body.BehaviorName == 1
        ? BEHAVIOUR_TYPE.POST
        : BEHAVIOUR_TYPE.GET
    const createDefaultLayoutData = ds.postCreateDefaultQuickKeylayoutData(
      body,
      methType
    )
    await createDefaultLayoutData
      .then(res => {
        if (res && res.data != '') {
          setIsLoading(false)
          if (res.msgCode == 'GENERAL_SUCCESS') {
            message.success(res.msgDescription)
            history.push(
              `/Dashboard/sell/settings/quickkeys/${
                res.data.quickKeyLayoutID
              }/${false}`
            )
          } else {
            message.success(res.msgDescription)
          }
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
      })
  }
  const onAddClick = () => {
    if (!StringIsNullOrEmpty(getSelectedRegID)) {
      let body = {
        QuickKeyLayoutID: '0&&_266b-bb8d-4e32-af79-ad98d06d4eb2',
        BehaviorName: 1,
        OutletID: getSelectedOutletID,
        RegisterID: getSelectedRegID
      }
      setIsLoading(true)
      CreateDefaultQuickKeyLayout(body)
    } else {
      message.info(
        'Kindly click Sell Menu & select Outlet/Register from left sidebar to open cash flow',
        6
      )
    }
  }
  function onDeleteLayoutClick (id) {
    if (getIsDisableDelete) {
      message.warn('You do not have permission to perform this...', 5)
    } else {
      let body = { QuickKeyLayoutID: id, BehaviorName: parseInt(2) }
      const formData = new FormData();
     formData.append('MainData', JSON.stringify(body));
      postQuickKeyLayoutDataServices(formData, BEHAVIOUR_TYPE.DELETE)
    }
  }
  async function postUpdateConfiguration(configKey, value) {
    let actionToDispatch = null;
  
    switch (configKey) {
      case 'IsShowSellAttribute':
        actionToDispatch = loadIsShowConfigAttribute(value);
        break;
      case 'IsShowSaleLayout':
        actionToDispatch = loadIsShowConfigSellLayout(value);
        break;
      case 'EnableAllPOSLayouts':
        actionToDispatch = loadEnableAllPOSLayouts(value);
        break;
      default:
        break;
    }
  
    if (actionToDispatch) {
      dispatch(actionToDispatch);
    }
  
    let body = {
      Key: configKey,
      Value: value ? 'True' : 'False'
    };
  
    try {
      const resp = await ds.updateStoreConfigService(body, BEHAVIOUR_TYPE.GET);
      setIsLoading(false);
      if (resp) {
        message.success('Successfully Updated');
      } else {
        message.error('Failed to Update');
      }
    } catch (e) {
      setIsLoading(false);
      notAllowMsgCheck(e);
    }
  }
  
  const handleChageProductStatus = (status, id) => {
    let body = {
      RowID : id,
      // TableName  : "quickkeylayouts", 
      IsActive : status
    };
    postActiveStatus(body);
  }
  async function postActiveStatus(body) {
    //setLoader(true);
    await ds.postTableActiveStatusData(body, BEHAVIOUR_TYPE.POST)
      .then(res => {
        if (res.data.data.isUpdated) {
          message.success(res.data.data.message)
          // window.location.reload();
              let updatedData = getLayoutData.map(quickKey => {
                  if (getDecryptID(quickKey.quickLayoutID)  === getDecryptID(body.RowID)) {
                      return { ...quickKey, isActive: body.IsActive };
                  }
                  return quickKey;
              });
              setLayoutData(updatedData);
        } else {
          message.error(res.data.data.message)
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        message.error('Something went wrong...')
      })
  }

  function showStatusConfirm (e, record) {
    
 
        const action = record.isActive ? "deactivate" : "activate";
        const title = `Are you sure you want to ${action} this menu on sale?`;
        confirm({
          title: title,
          content: `"${record.layoutName}"`,
          okText: 'Yes',
          cancelText: 'No',
          okButtonProps: { className: 'dk-btn-add close-reg-btn' },
          cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
          onOk () {
            handleChageProductStatus(e, record.quickLayoutID)
          },
          onCancel () {
            //console.log('Cancel');
          }
        })
   }

  const handleCurrentLayout = (e, quickLayoutID) => {
    setIsLoading(true)
    let body = {
      QuickKeyLayoutID: quickLayoutID,
      BehaviorName: 1,
      OutletID: getSelectedOutletID,
      RegisterID: getSelectedRegID
    }
    postQuickKeyCurrentLayout(body, BEHAVIOUR_TYPE.UPDATE)
  }
  function onRemoveClick () {}
  function onEditClick (e, isCopy = false) {
    history.push(`/Dashboard/sell/settings/quickkeys/${e}/${isCopy}`)
    // if (getIsDisableUpdate) {
    //   message.warn("You do not have permission to update this", 5);
    // } else {

    // }
  }
  const CardsListItem = ({ styleName, data }) => {
    const { quickLayoutID, layoutName, isCurrentLayout, isActive,displaySeqNo } = data
    return (
      <div className={`gx-user-list ${styleName}`}>
          
        <div className='gx-flex-row align-items-center ud-responsive-1'>
        <div className='seq-no'>{displaySeqNo}</div>
          <h4>{layoutName}</h4>
        </div>
        <ul className='gx-app-nav icons-btn-div  ud-responsive-2'>
          <li>
            {isCurrentLayout ? (
              <span style={{ marginLeft: '5px' }} className='vd-flag sm:hidden'>
                {' '}
                <IntlMessages id='sell.settings.currentlayout' />
              </span>
            ) : (
              <Button
                type='primary'
                className='grey-btn-div'
                onClick={e => handleCurrentLayout(e, quickLayoutID)}
              >
                <IntlMessages id='sell.settings.setascurrentlayout' />
              </Button>
            )}
          </li>


          <li>
          <Switch
            checked={isActive}
            onChange={e => showStatusConfirm(e, data)}
            disabled={getIsDisableDelete}
          />
          </li>
          <li>
            {!getIsDisableUpdate ? (
              <a
                onClick={() => {
                  onEditClick(quickLayoutID)
                }}
                // href={getIsDisableUpdate ? "#" : "/Dashboard/sell/settings/quickkeys/" + quickLayoutID}
                className='pen-edit'
              >
                <i className='icon icon-edit'> </i>
              </a>
            ) : (
              <></>
            )}
          </li>
          <li>
            <a
              onClick={() => {
                onEditClick(quickLayoutID, true)
              }}
              className='gx-link'
            >
              <i className='icon icon-copy'> </i>
            </a>
          </li>
          <li className='delete-bt'>
            <i
              className='icon icon-trash'
              onClick={() => onDeleteLayoutClick(quickLayoutID)}
            />
          </li>
        </ul>
      </div>
    )
  }
  return getIsAllowRead ? (
    <>
      <Spin
        tip={<IntlMessages id='common.resource.loading' />}
        spinning={isLoading}
        size='large'
      >
        <div className='Content-wrapper Settings-pg'>
          {getSelectedOutletID && getSelectedRegID ? (
            <>
              {checkIsWeb().exist && (
                <Row>
                  <Col span={24}>
                    <h1 className=''>
                      <IntlMessages id='sell.settings.settings' />
                    </h1>
                  </Col>
                </Row>
              )}

              <Row className='dk-row-bg-color m-0 Sec-heading-bg'>
              <Col lg={24} md={24} sm={24} xs={24}>
                  <p className='title vd-hero-intro custom-font-color-black m-0'>
                    <IntlMessages id='sell.settings.manageyourregistersettings' />
                  </p>
                </Col>
              </Row>

              <div className='custom-mg-top-25'>
             
                <Row className='SellAttribute-div'>
                
                <Col lg={6} md={24} sm={24} xs={24}>
                    <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                      <IntlMessages id='sell.settings.sellattributes' />
                    </h2>
                    <p className='custom-font-size-15'>
                      {' '}
                      <IntlMessages id='sell.settings.sellattributesdesc' />
                    </p>
                  </Col>

                  <Col lg={18} md={24} sm={24} xs={24} className="">
                
                      <div className='settings-div'>
                        <Switch
                          checked={getConfigSellAttribute}
                          onClick={e => {
                            postUpdateConfiguration('IsShowSellAttribute', e)
                          }}
                        />
                        <h3> <IntlMessages id='sell.settings.enablesellattributes' /> </h3>
                        <p> <IntlMessages id='sell.settings.enablesellattributesdesc' /> </p>
 
                      <div className='quick-key-layout-list'>
                        <Button
                          className='dk-btn-add mt-2'
                          type='primary'
                          onClick={() => {
                            history.push(
                              '/dashboard/sell/settings/sellattributesgroup'
                            )
                          }}
                          disabled={getIsDisableCreate}
                          size={'large'}
                        >
                          <IntlMessages id='sell.settings.addsellattributegroup' />
                        </Button>
                        <Button
                          className='dk-btn-add mt-2'
                          type='primary'
                          onClick={() => {
                            history.push(
                              '/dashboard/sell/settings/sellattributes'
                            )
                          }}
                          disabled={getIsDisableCreate}
                          size={'large'}
                        >
                          <IntlMessages id='sell.settings.addsellattributes' />
                        </Button>
                      </div>
                      </div>

                  </Col>
                </Row>

                <Divider className='custom-mgt-mgb-35' />

                <Row className='QuickKeys-div'>
                 
                <Col lg={6} md={24} sm={24} xs={24}>
                  <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                      <IntlMessages id='sell.settings.quickkeys' />
                    </h2>
                    <p className='custom-font-size-15'>
                      {' '}
                      <IntlMessages id='sell.settings.quickkeysdescription' />
                    </p>
                  </Col>

                  <Col lg={18} md={24} sm={24} xs={24} className="">

                      <div className='settings-div'>
                        <Switch
                          checked={getConfigSellLayout}
                          onClick={e => {
                            postUpdateConfiguration('IsShowSaleLayout', e)
                          }}
                        />
                        <h3><IntlMessages id='sell.settings.enablequickkeyregister' /></h3>
                        <p> <IntlMessages id='sell.settings.enablequickkeyregisterdescp' /> </p>
                      
                        <Switch
                          checked={getEnableAllPOSLayouts}
                          onClick={e => {
                            postUpdateConfiguration('EnableAllPOSLayouts', e)
                          }}
                        />
                        <h3>Enable Layout on Point-of-Sale</h3>
                        <p>Toggle the switch to enable your layouts on point of sale screen. You can turn this back on at anytime without losing your settings.</p>

                      <div className='quick-key-layout-list'>
                        <Button
                          className='custom-searchbtn custom-width-180 dk-btn-add'
                          type='primary'
                          onClick={() => onAddClick()}
                          disabled={getIsDisableCreate}
                        >
                          <IntlMessages id='sell.settings.addlayout' />
                        </Button>
                      </div>
                      </div>

                    
                    
                        <div className='Quick-keys-wrapper'>
                          {getLayoutData &&
                            getLayoutData.length > 0 &&
                            getLayoutData.map((data, index) => (
                              <CardsListItem
                                key={index}
                                data={data}
                                styleName='gx-card-list dk-content-space-bw'
                              />
                            ))}
                        </div>
                     
                   
                  </Col>
                </Row>
              </div>
            </>
          ) : (
            <>
              <Row justify='center'>
                <Col>
                  <h1>Kindly Select Register and Outlet</h1>
                </Col>
              </Row>
            </>
          )}
        </div>
      </Spin>
    </>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default QuickLayoutListing
